// extracted by mini-css-extract-plugin
export default {"container":"K_-z","oos":"L_-z","oosCefi":"M_-z","oosUx":"N_-z","optionButton":"O_-z","optionButtonContainer":"P_-z","optionButtonSelected":"Q_-z","selected":"R_-z","labelOos":"S_-z"};